import { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import Modal from "@mui/material/Modal";
import Backdrop from "@mui/material/Backdrop";
import { Box, TextField, Select, Button } from "@mui/material";
import { toast } from "react-toastify";
import { BsTrash } from "react-icons/bs";
import { getProductosKaeAlmacen, getProductosKae, createStockKae, updateStockKae, deleteStockKae } from "../../../../services";
import LaeButton from "../../../../components/Buttons/LaeButton";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "85ch",
  maxHeight: "80vh",
  overflow: "auto",
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
};

const EditarStock = ({ almacen, opened, handleClose }) => {
  const { t } = useTranslation(["common"]);
  const [listaStock, setListaStock] = useState([]);
  const [todosProductos, setTodosProductos] = useState([]);
  const [eliminados, setEliminados] = useState([]);

  useEffect(() => {
    if (opened && almacen?.id) {
      cargarDatos();
    }
  }, [opened, almacen]);

  const cargarDatos = async () => {
    try {
      const [productosAlmacen, todosProds] = await Promise.all([
        getProductosKaeAlmacen(almacen.id),
        getProductosKae(),
      ]);
      const items = Array.isArray(productosAlmacen) ? productosAlmacen : [];
      setListaStock(
        items.map((p) => ({
          id: p.id,
          stock_id: p.stocks?.[0]?.id,
          nombre: p.nombre,
          cantidad: p.stocks?.[0]?.cantidad || 0,
          stock_minimo: p.stocks?.[0]?.stock_minimo || 0,
          stock_maximo: p.stocks?.[0]?.stock_maximo || 0,
          isNew: false,
        }))
      );
      setTodosProductos(Array.isArray(todosProds) ? todosProds : []);
      setEliminados([]);
    } catch (error) {
      console.error(error);
    }
  };

  const getProductosDisponibles = (currentIndex) => todosProductos.filter(
    (p) => !listaStock.some((s, i) => i !== currentIndex && (s.id === p.id || s.producto_id === p.id))
  );

  const handleAddItem = () => {
    setListaStock([
      ...listaStock,
      { producto_id: "", nombre: "", cantidad: 0, stock_minimo: 0, stock_maximo: 0, isNew: true },
    ]);
  };

  const handleRemoveItem = (index) => {
    const item = listaStock[index];
    if (item.stock_id) {
      setEliminados([...eliminados, item]);
    }
    setListaStock(listaStock.filter((_, i) => i !== index));
  };

  const handleInputChange = (index, event) => {
    const { name, value } = event.target;
    const updated = [...listaStock];
    updated[index] = { ...updated[index], [name]: Number(value) };
    setListaStock(updated);
  };

  const handleSelectProducto = (index, event) => {
    const productoId = parseInt(event.target.value);
    const producto = todosProductos.find((p) => p.id === productoId);
    const updated = [...listaStock];
    updated[index] = {
      ...updated[index],
      producto_id: productoId,
      nombre: producto?.nombre || "",
    };
    setListaStock(updated);
  };

  const handleSubmit = async () => {
    const toastInfo = toast.info(t("almacenes.messages.saving"), { autoClose: false });
    try {
      const promesas = [];
      // Crear stock nuevo
      const nuevos = listaStock.filter((item) => item.isNew);
      console.log("items nuevos:", nuevos);
      nuevos.filter((item) => item.producto_id).forEach((item) => {
        promesas.push(createStockKae({ producto_id: item.producto_id, almacen_id: almacen.id, cantidad: item.cantidad, stock_minimo: item.stock_minimo, stock_maximo: item.stock_maximo }));
      });

      // Actualizar stock existente
      listaStock.filter((item) => !item.isNew && item.id).forEach((item) => {
        promesas.push(updateStockKae({ cantidad: item.cantidad, producto_id: item.id, almacen_id: almacen.id, stock_minimo: item.stock_minimo, stock_maximo: item.stock_maximo }));
      });

      // Eliminar stock
      eliminados.filter((item) => item.id).forEach((item) => {
        promesas.push(deleteStockKae(item.id));
      });

      await Promise.all(promesas);

      toast.update(toastInfo, {
        render: t("almacenes.messages.editedSuccess"),
        type: toast.TYPE.SUCCESS,
        autoClose: true,
      });
      handleClose();
    } catch (err) {
      console.log(err);
      toast.update(toastInfo, {
        render: t("almacenes.messages.editError"),
        type: toast.TYPE.ERROR,
        autoClose: true,
      });
    }
  };

  return (
    <div>
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        style={{ display: "flex", alignItems: "center", justifyContent: "center" }}
        open={opened}
        onClose={handleClose}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{ timeout: 500 }}
      >
        <Box sx={style}>
          <div
            style={{
              backgroundColor: "#fff",
              border: "2px solid #000",
              boxShadow:
                "0px 3px 5px -1px rgba(0,0,0,0.2),0px 5px 8px 0px rgba(0,0,0,0.14),0px 1px 14px 0px rgba(0,0,0,0.12)",
              padding: "16px 32px 24px",
            }}
          >
            <h2 id="transition-modal-title">Editar Stock</h2>
            <div id="transition-modal-description">
              {listaStock.length === 0 ? (
                <div style={{ margin: 15 }}>
                  <p>No hay productos en este almacén</p>
                </div>
              ) : (
                listaStock.map((item, index) => (
                  <div key={index}>
                    <Box
                      mx={1}
                      display={"flex"}
                      flexDirection={"row"}
                      alignItems={"center"}
                    >
                      {item.isNew ? (
                        <Select
                          native
                          name="producto_id"
                          style={{ width: "40%", margin: "5px" }}
                          value={item.producto_id || ""}
                          onChange={(e) => handleSelectProducto(index, e)}
                        >
                          <option value="">Seleccionar producto</option>
                          {getProductosDisponibles(index).map((p) => (
                            <option key={p.id} value={p.id}>
                              {p.nombre}
                            </option>
                          ))}
                        </Select>
                      ) : (
                        <span
                          style={{
                            width: "40%",
                            margin: "5px",
                            fontSize: "14px",
                            fontWeight: "bold",
                          }}
                        >
                          {item.nombre}
                        </span>
                      )}
                      <TextField
                        style={{ width: "15%", margin: "5px" }}
                        type="number"
                        label="Cantidad"
                        variant="outlined"
                        name="cantidad"
                        onChange={(e) => handleInputChange(index, e)}
                        InputLabelProps={{ shrink: true }}
                        value={item.cantidad}
                      />
                      <TextField
                        style={{ width: "15%", margin: "5px" }}
                        type="number"
                        label="Stock mínimo"
                        variant="outlined"
                        name="stock_minimo"
                        onChange={(e) => handleInputChange(index, e)}
                        InputLabelProps={{ shrink: true }}
                        value={item.stock_minimo}
                      />
                      <TextField
                        style={{ width: "15%", margin: "5px" }}
                        type="number"
                        label="Stock máximo"
                        variant="outlined"
                        name="stock_maximo"
                        onChange={(e) => handleInputChange(index, e)}
                        InputLabelProps={{ shrink: true }}
                        value={item.stock_maximo}
                      />
                      <div style={{ display: "flex", flexWrap: "wrap" }}>
                        <button
                          onClick={() => handleRemoveItem(index)}
                          style={{
                            backgroundColor: "transparent",
                            color: "#000",
                            height: 30,
                            border: "none",
                            cursor: "pointer",
                          }}
                        >
                          <BsTrash />
                        </button>
                      </div>
                    </Box>
                  </div>
                ))
              )}
              <Box mx={2} my={3} display={"flex"} flexDirection={"row"}>
                <button
                  className="btn-Secondary"
                  style={{ color: "white", padding: "6px 12px", border: "none", borderRadius: "4px", cursor: "pointer" }}
                  onClick={handleAddItem}
                >
                  Añadir producto
                </button>
              </Box>
              <div
                style={{
                  margin: "8px",
                  marginTop: "16px",
                  position: "relative",
                  display: "grid",
                  gridTemplateColumns: "repeat(2, 1fr)",
                  gridGap: "15px",
                  fontSize: "12px",
                }}
              >
                <Button
                  variant="contained"
                  sx={{
                    flex: 1,
                    backgroundColor: "whitesmoke",
                    color: "#92004D",
                    ":hover": { backgroundColor: "#92004D", color: "white" },
                    margin: 0,
                    p: 1,
                  }}
                  disableElevation
                  onClick={handleClose}
                >
                  {t("actions.cancel")}
                </Button>
                <LaeButton sx={{ flex: 1 }} onClick={handleSubmit}>
                  {t("actions.save")}
                </LaeButton>
              </div>
            </div>
          </div>
        </Box>
      </Modal>
    </div>
  );
};

export default EditarStock;
